<template>
  <div class="avatar">
    <dp-dropdown
      placement="bottom-start"
      class=""
      @dropdown-item-click="logOut"
    >
      <dp-avatar shape="circle" size="medium" :src="imageSrc"> </dp-avatar>
      <dp-dropdown-menu class="dpmenu" slot="menu">
        <dp-dropdown-item icon="log-out" @>
          {{ $t("pageLanguage.Logout") }}
        </dp-dropdown-item>
      </dp-dropdown-menu>
    </dp-dropdown>
  </div>
</template>

<script>
import axios from "axios";
import { IMAGE_BASE_URL, oauthAuthHeader, M_BASE_URL } from "../../utils";
//L_BASE_URL,

export default {
  data() {
    return {
      isShow: false
    };
  },
  methods: {
    async logOut() {
      let Base_Url = M_BASE_URL + "/api";
      let path = `/logout`;
      let config = {
        method: "GET",
        url: Base_Url + path,
        headers: {
          ...oauthAuthHeader()
        }
      };
      await axios(config)
        .then(res => {
          if (res.status == 200) {
            if (process.client && localStorage.getItem("DIRECT_LINK")) {
              // const DIRECT_LINK = decodeURIComponent(
              //   localStorage.getItem("DIRECT_LINK")
              // );

              window.localStorage.clear();
              //window.location.href = L_BASE_URL + "/#/login";
            } else {
              this.$store.dispatch("addLinkquaryccActions", "");
              this.$store.dispatch("addLinkquarynameActions", "");
              this.$store.dispatch("addLinkStartDateActions", "");
              this.$store.dispatch("addLinkEndDateActions", "");
              this.$store.dispatch("addRepoClientList", "");
              window.localStorage.clear();
              this.$router.push({ name: "Logout" });
              //  window.location.href = "https://my.digitastic.app/#/login"
            }
          }
        })
        .catch(() => {
          this.$message({
            message: "wir steigen aus",
            type: "error"
          });
        })
        .finally(() => {
          //("tamamlandı");
        });
    }
  },

  computed: {
    userNameHeader() {
      return localStorage.getItem("username");
    },
    imageSrc() {
      const avatar = localStorage.getItem("image");
      return IMAGE_BASE_URL + avatar + "/300x90.png";
    }
  }
};
</script>

<style>
.dpmenu {
  z-index: 1063;
  transform-origin: center top;
  position: absolute;
  will-change: transform;
  top: 0px;
  left: 0px im;
  transform: translate3d(-85px, 40px, 0px);
}
</style>
